<template>
  <database-management-modal :element="category" ref="modal">
    <template v-slot:body>
      <div :class="hasErrorClass($v.category.name, 'form-group')">
        <label class="control-label">* Name</label>

        <input
          name="name"
          type="text"
          class="form-control"
          placeholder="Category Name"
          v-model="$v.category.name.$model" />

        <vuelidate-help :field="$v.category.name" label="Name" />
      </div>
      <div :class="hasErrorClass($v.category.currency, 'form-group')">
        <label class="control-label">Currency</label>

        <selectize
          class="selectize selectize-single form-control"
          name="currency"
          :options="currencyFieldOptions"
          v-model="$v.category.currency.$model"
          :disable-delete="true">
        </selectize>

        <vuelidate-help :field="$v.category.currency" label="Currency" />
      </div>
      <div :class="hasErrorClass($v.category.hide_budget, 'form-group')">
        <label class="control-label">* Hide Budget</label>
        <div class="checkbox checkbox-primary">
          <div class="input-group-checkbox">
            <input
              type="checkbox"
              id="hide_budget"
              name="hideBudget"
              v-model="$v.category.hide_budget.$model"
            >
            <label for="hide_budget">
              Hide budget from non-admin users when they view an appearance with this category
            </label>
            <vuelidate-help :field="$v.category.hide_budget" label="Hide Budget" />
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <ladda-button :click="saveCategory" type="button" class="btn btn-lg btn-primary pull-right" data-dismiss="modal"><i class="fa fa-check"></i> Save</ladda-button>
    </template>
  </database-management-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import VuelidateHelp from '../../misc/VuelidateHelp'
import Selectize from '../../ext/codium/CodiumSelectize'
import { http, notify } from 'utils'
import DatabaseManagementModal from './templates/DatabaseManagementModal'
export default {
  components: {DatabaseManagementModal, VuelidateHelp, Selectize},

  props: {
    category: {
      required: true
    }
  },

  data () {
    return {
      currencyFieldOptions: [
        { id: 'none', text: 'None' },
        { id: 'points', text: 'Points' },
        { id: 'AUD', text: 'AUD' },
        { id: 'GBP', text: 'GBP' },
        { id: 'USD', text: 'USD' },
        { id: 'CAD', text: 'CAD' },
        { id: 'NZD', text: 'NZD' },
        { id: 'EUR', text: 'EUR' }
      ]
    }
  },

  watch: {
    'category.id' (newValue, oldValue) {
      if (newValue.currency === null) {
        this.category.currency = 'none'
      }
    }
  },

  methods: {
    hasErrorClass (field, classes) {
      return field.$error ? `${classes} has-error` : `${classes}`
    },

    closeModal () {
      this.$refs.modal.closeModal()
    },

    saveCategory () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.reject(new Error('Data invalid'))
      }
      const endpoint = this.category.id ? `categories/${this.category.id}/update` : 'categories'
      const data = this.category
      if (this.category.currency === 'none') {
        data.currency = null
      }
      return http.put(endpoint, this.category).then((response) => {
        if (!this.category.id) {
          this.$emit('create', response.data)
        } else {
          this.$emit('update', response.data)
        }
        this.closeModal()
      })
    }
  },

  validations: {
    category: {
      name: {
        required
      },
      currency: {},
      hide_budget: {
        required
      }
    }
  }
}
</script>
